module.exports = {"id":"156683","name":"Samuel Holmén","rating":"72","photo":"./data/images/photos/2/156683.png","club":{"name":"IF Elfsborg","logo":"./data/images/clubs/IFElfsborg.png"},"positions":["MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SamuelHolmen0.json
// module id = 3810
// module chunks = 0